import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Authoritative {
  /* 分类列表 */
  static getRuleTypeList() {
    const url = `/zzd/api/back/regulation/category/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增分类 */
  static postAddRuleType(data) {
    const url = `/zzd/api/back/regulation/category/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 重命名 */
  static postRename(data) {
    const url = `/zzd/api/back/regulation/category/rename`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除规制分类 */
  static postDelRuleType(data) {
    const url = `/zzd/api/back/regulation/category/delete`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 规制列表 */
  static getRuleList(options) {
    let url = `/zzd/api/back/regulation/title/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除规制 */
  static postDelRule(data) {
    const url = `/zzd/api/back/regulation/title/delete`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑规制 */
  static postModRule(data) {
    const url = `/zzd/api/back/regulation/title/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增规制 */
  static postAddRule(data) {
    const url = `/zzd/api/back/regulation/title/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Authoritative